import navigationDrawerSignal, {
	closeNavigationDrawer,
	openNavigationDrawerAt,
} from '@Guidelines/Shell/AppShell/Signals/navigationDrawerSignal';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useSignalValue } from '@verclam/pulsar';

export type NavigationDrawerState = {
	readonly isOpen: boolean;
	readonly open: () => void;
	readonly close: () => void;
};

/** Open only on the navigation where it was opened: navigating anywhere closes it. */
const useNavigationDrawer = (): NavigationDrawerState => {
	const { key } = useLocation();
	const openedOn = useSignalValue(navigationDrawerSignal);

	const open = React.useCallback(() => {
		openNavigationDrawerAt(key);
	}, [key]);

	return { isOpen: openedOn === key, open, close: closeNavigationDrawer };
};

export default useNavigationDrawer;
